module.exports = __webpack_public_path__ + "entry-150bfe9b/bmw-photo-b1b66729fee065cefe12f6c150178d17.webp";